import React from "react"
import DashboardCard from "../DashboardCard/DashboardCard"

import css from '../TopUsers/TopUsers.module.css'
import ErrorOverlay from '../ErrorOerlay/ErrorOerlay'
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay"
import FullMessageOverlay from "../FullMessageOverlay/FullMessageOverlay"
import Tooltip from "@/shared/components/organism/Tooltip/Tooltip"

type ObjectTopItem = {
  id: number
  place: number;
  name: string;
  value: string;
  tooltip?: string;
  isEmpty: boolean
}

type ObjectTopProps = {
  top: ObjectTopItem[]
  title: string;
  col: number;
  row: number;
  loading: boolean;
  error: string | null; 
  fullMessage?: string;
  setOpenPopup?: () => void
  unit?: string;
}

const ObjectTop: React.FC<ObjectTopProps> = ({
  top,
  title,
  col,
  row,
  loading,
  error,
  fullMessage,
  setOpenPopup,
  unit = ''
}) => {
  return (
    <DashboardCard col={col} rowSpan={row} height={row * 50} title={title} isHover onClick={setOpenPopup}>
      {loading ? (
        <LoadingOverlay loading />
      ) : error ? (
        <ErrorOverlay error={error} />
      ) : fullMessage ? (
        <FullMessageOverlay fullMessage={fullMessage} />
      ) : (
        <div className={css.list}>
          {top.map(obj =>
            "isEmpty" in obj && obj.isEmpty ? (
              <div key={obj.id} className={css.item}>
                <div className={css.col1} style={{fontWeight: '600'}}>
                  {obj.place}
                </div>
                <div className={css.col2} style={{ color: "#ccc" }}>
                  —
                </div>
                <div className={css.col3} style={{ color: "#ccc" }}>
                  
                </div>
                <div className={css.col4} style={{ color: "#ccc" }}>
                  —
                </div>
              </div>
            ) : (
              <Tooltip key={obj.id} text={obj.name} position="cursor">
                <div
                  className={css.item}>
                  <div className={css.col1}>
                    {obj.place}
                  </div>
                  <div className={css.col2 + ' ' + css.ellipsis}>{obj.name}</div>
                  <div className={css.col3} style={{fontWeight: '600'}}>{obj.value} {unit}</div>
                  
                  </div>
              </Tooltip>
            )
          )}
        </div>
      )}
    </DashboardCard>
  )
}

export default ObjectTop 
export type { ObjectTopItem }